<div soho-busyindicator
    [style.height]="'100%'"
    [text]="' '"
    [blockUI]="true"
    [displayDelay]="20"
    [timeToComplete]="this.uiLoadingIndicatorTimeout"
    [transparentOverlay]="true"
>
  <div soho-datagrid #SohoDataGrid
      *ngIf="gridOptions"

      [attr.id]="dataGridId"
      [attr.data-automation-id]="dataGridAutomationId"
      [dataset]="treeData"
      [treeGrid]="true"
      [emptyMessage]="emptyMessage"
      [gridOptions]="gridOptions"

      (filtered)="onColumnFiltered($event)"
      (cellchange)="onCellChange($event)"
      (contextMenu)="onContextMenu($event)"
      (rowClicked)="onRowClicked($event)"
      (rowDoubleClicked)="onRowDoubleClicked($event)"
      (closeFilterRow)="onCloseFilterRow($event)"
      (openFilterRow)="onOpenFilterRow($event)"
      (selected)="onRowsSelected($event)"
      (expandrow)="onExpandRow($event)"
      (collapserow)="onCollapseRow($event)"
      (rowActivated)="onRowActivated($event)"
      (keydown)="onKeyDown($event)"
      (filteroperatorchanged)="onFilterOperatorChanged($event)"
  >
  </div>
</div>
